//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { GiftCardsLargeSVG } from './svg'

interface GiftCardsLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const GiftCardsLargeIcon: React.FC<GiftCardsLargeIconProps> = forwardRef<
  GiftCardsLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon ref={ref} boxSize={boxSize} as={GiftCardsLargeSVG} sx={sx} />
))
